import axios from 'axios'
import React, { useEffect, useState } from 'react'
import NoDataFound from '../utilsComponent/noDataFound'
import { REACT_APP_KSHEMA_POC2, REACT_APP_VAM_CONTEXT_EXCESS, REACT_APP_VAM_CONTEXT_INDEMNITY, REACT_APP_VAM_ENDPOINT } from '../urls'
import { Modal, ModalBody, ModalFooter, ModalHeader, Button } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import { toast } from 'react-toastify'
import { format } from 'date-fns'
import ListsPagination from '../utilsComponent/ListsPagination'
import { editModeOn, getFromDecreaptLocalStorage } from '../utilFunctions'
import { axiosRequest } from '../service'
import { functionalities } from '../consts'

function ExcessMasters(props) {
    const {roleDataCookie, productNames} = props
    const [excessMaterLists, setExcessMaterLists] = useState([])
    const [showAddPopover, setShowAddPopover] = useState(false);
    const [editMode, setEditMode] = useState(false)
    const defaultPayload = {  
        "id": null, 
        "productID": 0,  
        "excessPercentage": 0,  
        "excessMin": 0,  
        "excessMax": 0,  
        "startDate": null,  
        "endDate": null,  
        "createdBy": roleDataCookie?.userID
    }
    const [excessMasterPayload, setExcessMasterPayload] = useState(defaultPayload)
    const [currentItems, setCurrentItems] = useState([])
    const [sortedProductId, setSortedProductId] = useState(true)
    const [sortedExcess, setSortedExcess] = useState(false)
    const [sortedExcessMin, setSortedExcessMin] = useState(false)
    const [sortedExcessMax, setSortedExcessMax] = useState(true)

    const handleAdd = () => {
        setShowAddPopover(!showAddPopover);
    };

    const handleSubmit = () => {

    }

    useEffect(() => {
        getExcessMaterLists()
    }, [])

    const getExcessMaterLists = () => {
        axiosRequest().get(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_EXCESS}/getAllExcessList`).then(data => {
            setExcessMaterLists(data.data)
        }).then(error => {
            console.log(error)
        }).catch(error => (
            console.log(error)
        )
        )
    }
    const addExcessMater = () => {
        if(!excessMasterPayload.productID){
            toast.error("Please Select Product Name.")
            return
        }else if(!excessMasterPayload.excessPercentage){
            toast.error("Please Enter Excess Percentage.")
            return
        }else if(!excessMasterPayload.excessMax){
            toast.error("Please Enter Excess Max.")
            return
        }else if(!excessMasterPayload.startDate){
            toast.error("Please Select Start Date.")
            return
        }else if(!excessMasterPayload.endDate){
            toast.error("Please Enter End Date.")
            return
        }else{
            if(editMode){
                axiosRequest().put(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_EXCESS}/updateExcess`,{
                    ...excessMasterPayload,
                    productID: excessMasterPayload.productID.value,
                }).then(data => {
                    setEditMode(false)
                    setExcessMasterPayload(defaultPayload)
                    getExcessMaterLists()
                    toast.success("Updated Excess Master Sucessfully.")
                    setShowAddPopover(false)
                }).catch(error => (
                    console.log(error)
                )
                )
            }else{
                axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${REACT_APP_VAM_CONTEXT_EXCESS}/createExcess`,{
                    ...excessMasterPayload,
                    productID: excessMasterPayload.productID.value,
                }).then(data => {
                    setExcessMasterPayload(defaultPayload)
                    getExcessMaterLists()
                    toast.success("Added Excess Master Sucessfully.")
                    setShowAddPopover(false)
                }).catch(error => (
                    console.log(error)
                )
                )
            }
        }
    }
    const hanldeDatechange = (date, key) => {
        if (date) {
            const year = date.getFullYear();
            const month = (date.getMonth() + 1).toString().padStart(2, '0')
            const dat1 = (date.getDate()).toString().padStart(2, '0')
            setExcessMasterPayload({ ...excessMasterPayload, [key]: `${year}-${month}-${dat1}` })
        }
    }
    const clickedOnEditMode = (data) => {
        setExcessMasterPayload({   
            "id": data.id,
            "productID": data.productID,  
            "excessPercentage": data.excessPercentage,  
            "excessMin": data.excessMin,  
            "excessMax": data.excessMax,  
            "startDate": data.startDate,  
            "endDate": data.endDate,  
            "createdBy": roleDataCookie?.userID
        })
        setEditMode(true);
        setShowAddPopover(true)
    }
    const addExcessMaster = () => {
        setExcessMasterPayload(defaultPayload)
        setShowAddPopover(!showAddPopover);
        setEditMode(false)
    }
    const sortingData = (data) => {
        switch (data) {
         case "sortedProductId":
             if (!sortedProductId) {
                 const lists = [...excessMaterLists]
                 lists.sort((a, b) => a.productID - b.productID)
                 setExcessMaterLists([...lists])
                 setSortedProductId(true)
             } else {
                 const lists = [...excessMaterLists]
                 lists.sort((a, b) => b.productID - a.productID)
                 setExcessMaterLists([...lists])
                 setSortedProductId(false)
             }
             break;
         case "sortedExcess":
             if (!sortedExcess) {
                 const lists = [...excessMaterLists]
                 lists.sort((a, b) => a.excessPercentage - b.excessPercentage)
                 setExcessMaterLists([...lists])
                 setSortedExcess(true)
             } else {
                 const lists = [...excessMaterLists]
                 lists.sort((a, b) => b.excessPercentage - a.excessPercentage)
                 setExcessMaterLists([...lists])
                 setSortedExcess(false)
             }
             break;
             case "sortedExcessMin":
                if (!sortedExcessMin) {
                    const lists = [...excessMaterLists]
                    lists.sort((a, b) => a.excessMin - b.excessMin)
                    setExcessMaterLists([...lists])
                    setSortedExcessMin(true)
                } else {
                    const lists = [...excessMaterLists]
                    lists.sort((a, b) => b.excessMin - a.excessMin)
                    setExcessMaterLists([...lists])
                    setSortedExcessMin(false)
                }
                break;
            case "sortedExcessMax":
                if (!sortedExcessMax) {
                    const lists = [...excessMaterLists]
                    lists.sort((a, b) => a.excessMax - b.excessMax)
                    setExcessMaterLists([...lists])
                    setSortedExcessMax(true)
                } else {
                    const lists = [...excessMaterLists]
                    lists.sort((a, b) => b.excessMax - a.excessMax)
                    setExcessMaterLists([...lists])
                    setSortedExcessMax(false)
                }
                break;
            //  case "sortedProductName":
            //      if (!sortedProductName) {
            //        const lists = [...excessMaterLists]
            //        lists.sort((a, b) => a.lastName?.toLowerCase().localeCompare(b.lastName?.toLowerCase()))
            //        setIndemnityLists([...lists])
            //        setSortedProductName(true)
            //      } else {
            //        const lists = [...indemnityLists]
            //        lists.sort((a, b) => b.lastName?.toLowerCase().localeCompare(a.lastName?.toLowerCase()))
            //        setIndemnityLists([...lists])
            //        setSortedProductName(false)
            //      }
            //      break;
       default:
     }
    
    }

    return (
        <section className="p-4">
            <h1 className="headerclaim">Excess Master</h1>
            <hr className="upper_hr" />
            <div className="outer-box_vendorMasters">
                <div style={{ justifyContent: 'space-between', display: 'flex', flexDirection: 'row', width: '100%' }}>
                    <h2 className="heading_h2Masters">Excess Master</h2>
                    {editModeOn(functionalities.EXCESS_MASTER_TAB) && (
                        <button className="btn btn-outline-success mt-4 mb-4 px-4" onClick={() => addExcessMaster()} style={{ marginRight: '2%' }}><i className="fa fa-plus" aria-hidden="false"></i>Add</button>
                    )}
                    <Modal show={showAddPopover} isOpen={showAddPopover} toggle={handleAdd} centered={true} backdrop={'static'}>
                        <ModalHeader>
                            {editMode ? <h5>Edit Excess</h5> : <h5>Add Excess</h5>}
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleAdd} ></button>
                        </ModalHeader>
                        <ModalBody>
                            <div className="form-group mb-3">
                                <form action>
                                    {
                                        !editMode && (
                                            <div className="form-group mb-3">
                                            <label for="exampleInputPassword1">Product Name</label>
                                                <Select id="exampleInputPassword1" options={productNames}
                                                    onInputChange={(inputValue) => {
                                                        // Replace non-alphanumeric characters
                                                        const cleanedValue = inputValue.replace(/[^A-Za-z]/g, '');
                                                        return cleanedValue; // Return cleaned value for the Select component
                                                    }}
                                                    placeholder="Kshema Product"
                                                    value={excessMasterPayload.productID.label ? excessMasterPayload.productID : { label: "Product"}}
                                                    onChange={(data) => {                    
                                                        setExcessMasterPayload({ ...excessMasterPayload, 'productID': data })
                                                    }}
                                                />
                                            </div>
                                        )
                                    }
                                    <div className="form-group mb-3">
                                        <label for="indemnitypercentage" className="form-label">Excess %</label>
                                        <input type="text" className="form-control" id="indemnitypercentage" placeholder="Excess %" onChange={(e) => {
                                            const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                            e.target.value = numericValue;
                                            setExcessMasterPayload({ ...excessMasterPayload, 'excessPercentage': Number(e.target.value) })
                                        }} value={excessMasterPayload.excessPercentage}/>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label for="indemnitypercentage" className="form-label">Excess Min</label>
                                        <input type="text" className="form-control" id="indemnitypercentage" placeholder="Excess Min" onChange={(e) => {
                                            const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                            e.target.value = numericValue;
                                            setExcessMasterPayload({ ...excessMasterPayload, 'excessMin': Number(e.target.value) })
                                        }} value={excessMasterPayload.excessMin}/>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label for="indemnitypercentage" className="form-label">Excess Max</label>
                                        <input type="text" className="form-control" id="indemnitypercentage" placeholder="Excess Max" onChange={(e) => {
                                            const numericValue = e.target.value.replace(/[^0-9.,]/g, '');
                                            e.target.value = numericValue;
                                            setExcessMasterPayload({ ...excessMasterPayload, 'excessMax': Number(e.target.value) })
                                        }} value={excessMasterPayload.excessMax}/>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label for="validitystart" className="form-label">Validity Start</label>
                                        <div className='form-control'>
                                          <DatePicker
                                            selected={excessMasterPayload?.startDate && excessMasterPayload?.startDate}
                                            // className="align4_dataPolicy"
                                            className="form-control" 
                                            id="validitystart"
                                            onChange={(date) => hanldeDatechange(date, 'startDate')}
                                            dateFormat="dd-MM-yyyy"
                                            placeholderText="dd-mm-yyyy"
                                            maxDate={excessMasterPayload?.endDate && excessMasterPayload?.endDate}
                                            // highlightDates={new Date()}
                                        />
                                        </div>
                                    </div>
                                    <div className="form-group mb-3">
                                        <label for="validitystart" className="form-label">Validity End</label>
                                        <div className='form-control'>
                                            <DatePicker
                                                selected={excessMasterPayload?.endDate && excessMasterPayload?.endDate}
                                                // className="align4_dataPolicy"
                                                minDate={excessMasterPayload?.startDate && excessMasterPayload?.startDate}
                                                onChange={(date) => hanldeDatechange(date, 'endDate')}
                                                dateFormat="dd-MM-yyyy"
                                                placeholderText="dd-mm-yyyy"
                                                // maxDate={new Date()}
                                                // highlightDates={new Date()}
                                            />
                                        </div>
                                    </div>
                                </form>
                            </div></ModalBody>
                        <ModalFooter style={{ justifyContent: 'center' }}>
                            <Button style={{ borderColor: 'green', backgroundColor: '#157347', color: 'white' }} onClick={() => addExcessMater()}>Save</Button>
                        </ModalFooter>
                    </Modal>
                </div>
                {
                    excessMaterLists && excessMaterLists.length > 0 ? (
                        <>
                            <table className="table table-strip mt-3 text-left">
                                <thead style={{ border: '1px solid black' }}>
                                    <tr>
                                        <th style={{ border: '1px solid black' }}>S No.</th>
                                        <th style={{ border: '1px solid black' }}>Product ID<a className="pointer text-body ms-1" onClick={() => sortingData("sortedProductId")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                        <th style={{ border: '1px solid black' }}>Excess %<a className="pointer text-body ms-1" onClick={() => sortingData("sortedExcess")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                        <th style={{ border: '1px solid black' }}>Excess Min %<a className="pointer text-body ms-1" onClick={() => sortingData("sortedExcessMin")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                        <th style={{ border: '1px solid black' }}>Excess Max %<a className="pointer text-body ms-1" onClick={() => sortingData("sortedExcessMax")}><svg xmlns="http://www.w3.org/2000/svg" className="pointer" width="16" height="16" fill="currentColor" className="bi bi-filter" viewBox="0 0 16 16">
                                                            <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5m-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5" />
                                                        </svg></a></th>
                                        <th style={{ border: '1px solid black' }}>Validity Start</th>
                                        <th style={{ border: '1px solid black' }}>Validity End</th>
                                        {editModeOn(functionalities.EXCESS_MASTER_TAB) && (
                                            <th style={{ border: '1px solid black' }}>Action</th>
                                        )}
                                    </tr>
                                </thead>
                                <tbody style={{ border: '1px solid black' }}>
                                    {
                                        currentItems.map((list, index) => (
                                            <tr>
                                                <td style={{ border: '1px solid black' }}>{index + 1}</td>
                                                <td style={{ border: '1px solid black' }}>{list.productID}</td>
                                                <td style={{ border: '1px solid black' }}>{list.excessPercentage}%</td>
                                                <td style={{ border: '1px solid black' }}>{list.excessMin}%</td>
                                                <td style={{ border: '1px solid black' }}>{list.excessMax}%</td>
                                                <td style={{ border: '1px solid black' }}>{format(new Date(list.startDate), 'dd-MMM-yyyy')}</td>
                                                <td style={{ border: '1px solid black' }}>{format(new Date(list.endDate), 'dd-MMM-yyyy')}</td>
                                                {editModeOn(functionalities.EXCESS_MASTER_TAB) && (
                                                    <td style={{ border: '1px solid black', backgroundColor: "#829ED1" }} onClick={() => clickedOnEditMode(list)} className='d-flex align-items-center justify-content-center'><FontAwesomeIcon icon="fas fa-edit" className='edit_button' /></td>
                                                )}
                                                {/* format(new Date(result.intimatedDate.split(".")[0]), 'dd-MM-yyyy, hh:mm a') */}
                                                {/* <Modal show={showAddPopover} isOpen={showAddPopover} toggle={handleAdd} centered={true} backdrop={'static'}>
                                                    <ModalHeader>
                                                        <h5>Edit Excess</h5>
                                                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={handleAdd} ></button>
                                                    </ModalHeader>
                                                    <ModalBody>
                                                        <div className="form-group mb-3">
                                                            <form action>
                                                                <div class="form-group mb-3">
                                                                    <label for="indemnitypercentage" class="form-label">Excess %</label>
                                                                    <input type="text" class="form-control" id="indemnitypercentage" placeholder="Excess %" />
                                                                </div>
                                                                <div class="form-group mb-3">
                                                                    <label for="indemnitypercentage" class="form-label">Excess Min</label>
                                                                    <input type="text" class="form-control" id="indemnitypercentage" placeholder="Excess Min" />
                                                                </div>
                                                                <div class="form-group mb-3">
                                                                    <label for="indemnitypercentage" class="form-label">Excess Max</label>
                                                                    <input type="text" class="form-control" id="indemnitypercentage" placeholder="Excess Max" />
                                                                </div>
                                                                <div class="form-group mb-3">
                                                                    <label for="validitystart" class="form-label">Validity Start</label>
                                                                    <input type="date" class="form-control" id="validitystart" />
                                                                </div>
                                                                <div class="form-group mb-3">
                                                                    <label for="validitystart" class="form-label">Validity End</label>
                                                                    <input type="date" class="form-control" id="validitystart" />
                                                                </div>
                                                            </form>
                                                        </div></ModalBody>
                                                    <ModalFooter style={{ justifyContent: 'center' }}>
                                                        <Button style={{ borderColor: 'green', backgroundColor: '#157347', color: 'white' }} onClick={() => handleSubmit()}>Save</Button>
                                                    </ModalFooter>
                                                </Modal> */}
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                            <ListsPagination setCurrentItems={setCurrentItems} lists={excessMaterLists}/>
                        </>
                    ) : <NoDataFound text="No Data Found" />
                }
            </div>
        </section>
    )
}

export default ExcessMasters;